var exports = {
  "U": "RoleIcon.module__roleIcon___TVZsVF",
  "Z": "RoleIcon.module__roleIconImage___TVZsVF",
};

module.exports = exports;
